import { Link } from 'react-router-dom';
import { NotepadText, Pin } from 'lucide-react';
import TrCourseImg from '../../../assets/images/TrainingCoursesImg.png';
import Image from "../../ui/Image";
import Riyal from '../../ui/riyal';
import { useTranslation } from 'react-i18next';

const TrainingCourseBox = ({ course , selectedCity}) => {
    const theImage = course?.type_course === 0 ? course?.image : course?.category?.image;
    const courseURL = selectedCity ? `/training-courses/${course?.id}?city_id=${selectedCity}` : `/training-courses/${course?.id}`;
    const { t } = useTranslation();
    return (
        <Link to={courseURL} className='relative min-h-[180px] pt-7 pb-3 px-3 grid grid-cols-[25%_74%] border rounded-lg w-full max-lg:w-full max-lg:grid-cols-1 gap-2'>

            <div className='relative w-32 bg-transparent max-lg:h-16'>
                <div className='lg:w-[7.5rem] lg:h-[7.5rem] flex justify-center items-center lg:absolute -top-[4.5rem] inset-y-0 -start-11 max-lg:h-28 max-lg:w-48 max-lg:relative max-lg:-start-7'>
                    <div className='bg-secondary-tw w-[7.8rem] h-[7.8rem] max-lg:h-[7.4rem] max-lg:w-[12.4rem] absolute z-0 rounded-lg'></div>
                    <Image
                        src={theImage || TrCourseImg}
                        alt={course?.title || 'course-title'}
                        className='object-cover w-full z-10 h-full rounded-lg'
                    />
                </div>
            </div>

            <div className='flex flex-col justify-between'>
                <div className=''>
                    <p className='text-primary-tw text-lg m-0 rtl:text-right ltr:text-left'>
                        {course?.title}
                    </p>

                    {(course?.subject?.category?.title && course?.subject?.category?.title !== "-") && (
                        <div className='flex items-center gap-2 mt-1 mb-1'>
                            <span>
                                <Pin fill='#7A7A7A' size={16} color='#7A7A7A' />
                            </span>
                            <p className='text-semi-gray text-sm m-0'>
                                {course?.subject?.category?.title}
                            </p>
                        </div>
                    )}

                    {
                        (course?.subject?.title && course?.subject?.title !== "-") && (
                            <div className="flex items-center gap-2  mt-1 mb-1">
                                <span>
                                    <NotepadText fill="white" size={16} color="#7A7A7A" />
                                </span>
                                <p className="text-semi-gray text-sm m-0">
                                    {course?.subject?.title}
                                </p>
                            </div>
                        )
                    }

                </div>

                <div className='flex items-end justify-end gap-2 flex-wrap max-lg:items-end'>
                    <p className=' text-semi-gray text-sm'>
                        {t('training-courses.price-start')} :
                    </p>

                    <p className='bg-primary-tw text-sm flex items-center gap-1 text-white px-3 py-0.5 rounded-lg'>
                        <span>
                            {course?.min_price || " 0 "}
                        </span>
                        <span className='w-3'>
                            <Riyal color="white" />
                        </span>
                    </p>
                </div>
            </div>
        </Link>
    )
}
export default TrainingCourseBox;